module.exports = __webpack_public_path__ + "img/92.f62392b8.jpg";